import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-error-reference',
  imports: [TranslatePipe],
  template: `
    @if (reference) {
      <small class="d-block mt-2 text-break user-select-text">
        {{ 'components.errorReference.label' | translate }}: {{ reference }}
      </small>
    }
  `,
})
export class ErrorReferenceComponent {
  @Input() public reference?: string;
}
